import setTotalPrice from "./SetTotalPrice";

export function totalPrice(wizardData, urlParams, stateTotalPrice) {
  const PRICE_LAST_STEP = 1;
  const steps = wizardData && wizardData.steps;

  let subTotalPrice = parseInt(wizardData.base_price);

  if (steps && steps.length > 0 && urlParams.step > 1) {
    for (let index = 2; index <= parseInt(urlParams.step); index++) {
      const stepValue = urlParams["step" + index];

      if (stepValue && stepValue !== "empty" && steps[index - 2]) {
        const stepFeatures = steps[index - 2].stepsFeatures;

        if (stepFeatures && stepFeatures.length > 0) {
          if (index - 1 === steps.length) {
            // last step
            subTotalPrice += PRICE_LAST_STEP;
          } else {
            // other steps
            subTotalPrice += setTotalPrice(
              stepFeatures,
              stepValue,
              stateTotalPrice
            );
          }
        }
      } else if (
        urlParams["step-custom-icon-index"] &&
        urlParams["step-custom-icon-index"] !== "empty"
      ) {
        // If last step is empty but exist a icon selection, sum 1€ to the price
        subTotalPrice += PRICE_LAST_STEP;
      }
    }
  }

  return subTotalPrice;
}

export default totalPrice;
